export type GradeLabel = 'Excellent' | 'Good' | 'Needs work' | 'Poor';

export function scoreToGrade(score: number): GradeLabel {
  if (score >= 90) return 'Excellent';
  if (score >= 70) return 'Good';
  if (score >= 50) return 'Needs work';
  return 'Poor';
}
